import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, ViewChild } from '@angular/core';
import { IonModal } from '@ionic/angular';
import { CLIMATE_MAX_TEMP, CLIMATE_MIN_TEMP } from 'src/app/shared/interfaces/climate.interface';
import { buildTempOptions, clampTemp } from './temperature-picker.helpers';

@Component({
  selector: 'temperature-picker',
  templateUrl: './temperature-picker.component.html',
  styleUrls: ['./temperature-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TemperaturePickerComponent implements OnChanges {
  @ViewChild(IonModal) modal!: IonModal;

  @Input() title = '';
  @Input() value = 0;
  @Input() min = CLIMATE_MIN_TEMP;
  @Input() max = CLIMATE_MAX_TEMP;
  @Input() disabled = false;

  @Output() onValueSelected = new EventEmitter<number>();

  public options: number[] = [];
  public display = 0;  // snapped current value shown on the panel
  public selected = 0; // wheel selection inside the modal

  public ngOnChanges(): void {
    this.options = buildTempOptions(this.min, this.max);
    this.display = clampTemp(this.value, this.min, this.max);
    this.selected = this.display;
  }

  public onColumnChange(event: CustomEvent): void {
    this.selected = Number(event.detail.value);
  }

  public open(): void {
    if (!this.disabled) {
      // Realign the wheel to the saved value so a scroll that was dismissed
      // without "Set" is discarded rather than re-offered on the next open.
      this.selected = this.display;
      this.modal.present();
    }
  }

  public onApply(): void {
    this.onValueSelected.emit(this.selected);
    this.modal.dismiss();
  }

  public label(t: number): string {
    return `${t}° F`;
  }
}
